/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';

import { EventForUser, EventGuest } from 'legacy/events/types';
import {
  useFriendRequestCommandsForSuggestedFriends,
  useGetMe
} from 'legacy/user/hooks';

import Button, { ButtonType } from 'legacy/common/components/button/Button';
import { useEventGuestListSearch } from 'legacy/search/hooks';
import UserImage from 'legacy/user/components/UserImage';
import Loader from 'legacy/common/components/layout/Loader';

type GuestSuggestionsProps = {
  event: EventForUser;
};

const GuestSuggestions: React.FC<GuestSuggestionsProps> = ({ event }) => {
  const { data: user } = useGetMe();
  const friendRequestCommands = useFriendRequestCommandsForSuggestedFriends({
    eventId: event._id
  });

  const {
    data: guests,
    isLoading: isLoadingGuests,
    refetch: refetchGuestList
  } = useEventGuestListSearch(false, event._id, '');

  const renderFriendAction = (guest: EventGuest) => {
    const friendStatus = guest.friendStatus;

    const { sendFriendRequestCommand } = friendRequestCommands;

    if (friendStatus === 'requestable') {
      return (
        <Button
          type={ButtonType.Clear}
          disabled={sendFriendRequestCommand.isLoading}
          onClick={() => {
            sendFriendRequestCommand.mutate(guest._id, {
              onSuccess: () => {
                refetchGuestList();
              }
            });
          }}
          data-testid={`button-send-friend-request-${guest._id}`}
        >
          <p className="mt-1 text-sm text-primary-400">Add Friend</p>
        </Button>
      );
    }

    if (friendStatus === 'requestSent') {
      return (
        <Button
          type={ButtonType.Clear}
          data-testid={`button-send-friend-request-${guest._id}`}
        >
          <p className="mt-1 text-sm text-gray-400">Requested</p>
        </Button>
      );
    }

    return null;
  };

  if (guests?.pages?.length === 0) {
    return null;
  }

  return (
    <div className="mb-10">
      <Loader isOverlay isLoading={isLoadingGuests}>
        <p className="text-lg font-semibold">Get to know the guest list</p>

        <div className="mt-4 flex flex-start flex-wrap">
          {guests?.pages?.map((page) =>
            page
              ?.filter((guest) => guest.id !== user?._id)
              .map((guest) => (
                <>
                  <div className="mt-2 mr-auto  text-center" key={guest._id}>
                    <a
                      href={`/profile/${guest._id}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block border-2 border-primary-400 w-20 h-20 md:w-24 md:h-24 rounded-full overflow-hidden"
                    >
                      <UserImage src={guest.photo?.url} className="block" />
                    </a>
                    <p className="mt-2 text-sm">{guest.firstName}</p>
                    {renderFriendAction(guest)}
                  </div>
                </>
              ))
          )}
        </div>
      </Loader>
    </div>
  );
};

export default GuestSuggestions;
